module.exports = __webpack_public_path__ + "static/media/free_movie_spirit_en.7fd431dd.png";